// extracted by mini-css-extract-plugin
export default {"container":"RoutinesSection_container__Cxj7j","divider":"RoutinesSection_divider__xYN+t"};